import React, { useState, useEffect } from 'react'
import { any, bool, string } from 'prop-types'
import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function AccordionItem({ content = null, isOpen = false, label = '' }) {
  const [isContentOpen, setIsContentOpen] = useState()

  const handleAccordionClick = () => {
    setIsContentOpen(!isContentOpen)
  }

  const contentSection = (
    <div
      role="presentation"
      onClick={handleAccordionClick}
      className={classnames(
        'accordion-item-content',
        isContentOpen && 'accordion-item-content--is-open'
      )}
    >
      {content}
    </div>
  )

  useEffect(() => {
    setIsContentOpen(isOpen)
  }, [isOpen])

  return (
    <li className="accordion-item cgt-card--border">
      <div
        className="accordion-item-head"
        onClick={handleAccordionClick}
        role="button"
      >
        <span className="accordion-item-label">{label}</span>

        <div
          className={classnames(
            'accordion-item-icon',
            isContentOpen && 'accordion-item-icon--is-open'
          )}
        />
      </div>

      {contentSection}
    </li>
  )
}

AccordionItem.propTypes = {
  content: any,
  isOpen: bool,
  label: string,
}

export default AccordionItem
